import { getAuthState, authUpdate } from '../functions'
import type { User, UserStat } from './types'

export const getAuthUser = () => {
    const state = getAuthState()
    return state.type === 'LoggedIn' ? state.data.user : null
}

export const getAuthToken = () => {
    const state = getAuthState()
    return state.type === 'LoggedIn' ? state.data.token : null
}

export const updateAuthUser = (user: User, token = getAuthToken()) => {
    if (!token) throw new Error('Unable to update auth: Missing token')
    return authUpdate({ token, user });
}

// TODO: Maybe move these two below into their own module?

export function getUserStats() {
    const user = getAuthUser()
    if (!user) return []

    const { userStats } = user
    return userStats ?? []
}

export function addUserStat(stat: UserStat) {
    const user = getAuthUser();
    if (!user) return

    const userStats = user.userStats ? [...user.userStats] : []
    const idx = userStats.findIndex(({ name }) => name === stat.name)

    if (idx >= 0) {
        // remove the existing one if necessary, as it will bubble to the end of the list
        userStats.splice(idx, 1)
    }

    userStats.push(stat)
    return updateAuthUser({ ...user, userStats })
}
